import { Alert, Col, Row } from 'react-bootstrap';
import OrderObj from './orderObj';
import OrderAgainButton from './OrderAgainButton';
import RefundOrder from './RefundOrder';

interface Props {
  order: OrderObj;
  showActions?: boolean;
}

export default function OrderDetails({ order, showActions = false }: Props) {
  return (
    <div className='order-details'>
      <div className='d-flex justify-content-between mb-3'>
        <div className='font-glegoo fs-23px fw-700'>Order Details</div>
        {showActions &&
          <div className='hstack gap-2'>
            {order.isRefundable() && <RefundOrder order={order} />}
            <OrderAgainButton order={order} />
          </div>
        }
      </div>
      <Row>
        <Col xs={12}>
          <Alert className='shadow-box bg-white text-black font-barlow fs-20px fw-700'>
            <Row>
              <Col xs={6} className='fs-5 fw-bold'>
                Product
              </Col>
              <Col xs={6} className='fs-5 fw-bold'>Total</Col>
            </Row>
          </Alert>          
        </Col>
      </Row>
      {order.data.line_items.map((item: Record<string, any> , i: number) => (
        <Row className='px-3 py-1' key={i}>
          <Col xs={6} className='fs-5'>
            {item.name} <span className='fw-bold'>x {item.quantity}</span>
          </Col>
          <Col xs={6} className='fs-5 fw-bold'>
            ${item.subtotal}
          </Col>
        </Row>
      ))}
      <Row className='my-2'>
        <Col xs={12}>
          <Alert className='shadow-box bg-white text-black font-barlow fs-20px fw-700'>
            <Row className='my-1'>
              <Col xs={6} className='fs-5 fw-bold'>
                Subtotal:
              </Col>
              <Col xs={6} className='fs-5 fw-bold'>
                {order.getSubtotal(true)}
              </Col>
            </Row>
            {order.data.discount_total && parseFloat(order.data.discount_total) > 0 &&
              <Row className='my-2'>
                <Col xs={6} className='fs-5 fw-bold'>
                  Discount:
                </Col>
                <Col xs={6} className='fs-5 fw-bold'>
                  ${order.data.discount_total}
                </Col>
              </Row>
            }
            <Row className='my-2'>
              <Col xs={6} className='fs-5 fw-bold'>
                Shipping:
              </Col>
              {order.data.shipping_lines.length > 0 && 
                <Col xs={6}>
                  <span className='fs-5 fw-bold'>${order.data.shipping_lines[0].total}</span><br />
                  via {order.data.shipping_lines[0].method_title}
                </Col>
              }
            </Row>
            <Row className='my-2'>
              <Col xs={6} className='fs-5 fw-bold'>Tax:</Col>
              <Col xs={6} className='fs-5 fw-bold'>${order.data.total_tax}</Col>
            </Row>
            <Row className='my-2'>
              <Col xs={6} className='fs-5 fw-bold'>Payment Method:</Col>
              <Col xs={6} className='fs-5'>
                {order.data.payment_method_title}
              </Col>
            </Row>
            <Row className='my-2'>
              <Col xs={6} className='fs-5 fw-bold'>Total:</Col>
              <Col xs={6} className='fs-5 fw-bold'>${order.data.total}</Col>
            </Row>
          </Alert>          
        </Col>
      </Row>
    </div>
  );
}